import { ENVS } from '@pelicargo/types';
import { z } from 'zod';

const rawAppEnv = import.meta.env.VITE_APP_ENV;

if (rawAppEnv && !rawAppEnv.includes(rawAppEnv as ENVS)) {
  throw new Error('Invalid APP_ENV. Please select one of: dev, stg, prd');
}

const envVariables = z.object({
  APP_ENV: z.string(),
  SUPABASE_URL: z.string(),
  SUPABASE_API_KEY: z.string(),
  SENTRY_DSN: z.string(),
  WS_API_URL: z.string(),
});

const env = {
  APP_ENV: import.meta.env.VITE_APP_ENV,
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  SUPABASE_API_KEY: import.meta.env.VITE_SUPABASE_API_KEY,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  WS_API_URL: import.meta.env.VITE_WS_API_URL,
};

let ENV: z.infer<typeof envVariables> = {};

try {
  ENV = envVariables.parse(env);
} catch (error) {
  if (error instanceof z.ZodError) {
    for (const issue of error.issues) {
      console.error(`ADMIN ENV VARIABLE ERROR: VITE_${issue.path[0]} is missing`);
    }
  }
}

export { ENV };
